import React from "react";

import { Grid, GridProps } from "@mui/material";

interface Props extends GridProps {
  children: React.ReactNode;
}

export function Item({ children, ...rest }: Props) {
  return (
    <Grid item {...rest}>
      {children}
    </Grid>
  );
}
